ACC.hintbox = {
  bindAll: function() {
    this.hintboxChange();
  },
  hintboxChange: function() {
    /* View hint info for input fields*/
    $('.ph-hinticon').click(function() {
      $(this).next().toggle();
    });

    $(document).on('tap mouseup', function(event) {
      var $container = $('.ph-hintmessage');

      if (!$container.is(event.target) && $container.has(event.target).length === 0) {
        $container.hide();
      }
    });
  }
};
$(document).ready(function() {
  ACC.hintbox.bindAll();
});
